import { BlendFunction, Effect } from 'postprocessing'
import { Uniform } from 'three'

const fragmentShader = /* glsl */`
    uniform float frequency;
    uniform float amplitude;
    uniform float offset;

    void mainUv(inout vec2 uv)
    {
        uv.y += sin(uv.x * frequency + offset) * amplitude;
    }

    // color
    void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor)
    {
        // first method
        // vec4 color = inputColor;
        // color.rgb *= vec3(0.8, 1.0, 0.5);
        // outputColor = color;

        //second method
        outputColor = vec4(0.8, 1.0, 0.5, inputColor.a);
    }
`

export default class DrunkEffect extends Effect
{
    constructor({ frequency, amplitude, offset, blendFunction = BlendFunction.DARKEN })
    {
        super(
            'DrunkEffect', 
            fragmentShader, 
            {
                // this
                blendFunction,
                //is the same as blendFunction: blendfunction,
                uniforms: new Map([
                    // first method
                    // [ 'frequency', { value: frequency } ],
                    // [ 'amplitude', { value: amplitude } ]

                    // second method using three.js
                    [ 'frequency',  new Uniform(frequency) ],
                    [ 'amplitude', new Uniform(amplitude) ],
                    // we could send time but we're going to do it a little differently //
                    [ 'offset', new Uniform(0) ]
                ])
            }
        )
    }
    
    update(renderer, inputbuffer, deltaTime)
    {
        this.uniforms.get('offset').value += deltaTime * 2.2
    }
}